<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iDIU5E/tc-custom/9781488044403.jpg?1708087307410" alt="This image is the cover for the book Spaniard's Baby of Revenge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spaniard's Baby of Revenge
      </h1>
      <p class="bookDescription body article font2">
        <b>Though their families are feuding, a one night stand leads to pregnancy and a marriage of convenience in this sexy enemies to lovers international romance.</b><br/><br/>His vengeance was strictly business . . . <br/><br/>Until he discovers she’s carrying his heir!<br/><br/>Antonio Herrera’s plan is simple: persuade innocent Amelia diSalvo to sell the shares in his rival’s business. But what the Spanish billionaire didn’t plan on was their intense connection. Now Antonio has only one aim . . . the ultimate seduction! So he’s stunned to discover their nine-month consequence. To secure his heir, he’ll do the unthinkable—and shockingly pleasurable—and make Amelia his wife!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clare Connelly
      </h2>
      
      <p class="authorDescription body article"><B>Clare Connelly</B> was raised in small-town Australia among a family of avid readers. She spent much of her childhood up a tree, Harlequin book in hand. She is married to her own real-life hero in a bungalow near the sea with their two&#160;children. She is frequently found staring into space - a surefire sign she is in the world of her characters. Writing for Harlequin Presents is a long-held dream. Clare can be contacted via clareconnelly.com or on her Facebook page.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1cbe9d89